import React, {
    useState,
    useEffect,
    useMemo
} from "react";
import { useToaster } from "rsuite"
import {
    Box,
    Paper,
    Typography,
    TextField,
    Button,
    Tabs,
    Tab,
    Avatar,
    Chip,
    Tooltip
} from "@mui/material"
import {
    PhotoCameraOutlined,
    PlaceOutlined,
    CheckCircleOutline,
    InfoOutlined
} from "@mui/icons-material"
import InstitutionMembers from "./components/institutionMember"
import { useNavigate } from "react-router-dom"
import {
    useCreatePlatformMutation
} from "../Redux/actions/setting.action"
import {
    ToastMessage,
    Loader
} from "../components/index"
import {
    useLazyGetUserInstitutionQuery,
    useUpdateInstitutionToUserAccountMutation,
    useCreateInstitutionMetadataMutation,
    useLazyGetInstitutionMetadataQuery,
    useUpdateInstitutionMetadataMutation,
    useUpdateInstitutionMutation
} from "../Redux/actions/setting.action"
import {
    useUploadImageMutation
} from "../Redux/actions/upload_content"

function PlatformSetup() {
    const toaster = useToaster()
    const navigation = useNavigate()
    const [user, setUser] = useState(null)
    const [state, setState] = React.useState({
        setup_step: "new_institution",
    })
    const [status, setStatus] = useState(null)


    const [alert, setAlert] = React.useState({
        show: false,
        message: "",
        type: "info",
        duration: "",
        alert_type: ""
    })
    const [institution, setInstitution] = React.useState({
        name: "",
        logo: "",
        state: "",
        district: "",
        pin: "",
        address: ""
    })
    const [institutionMetadata, setMetadata] = React.useState({
        institutionCode: "",
        institutionEmail: "",
        institutionContact: "",
        institutionType: "",
        establishmentYear: "",
        board: ""
    })
    const [createPlatform, createState] = useCreatePlatformMutation()
    const [getUserInstitutionAction, getUserInstitution] = useLazyGetUserInstitutionQuery()
    const [updateInstitutionToUserAccountAction, updateUserInstitutionState] = useUpdateInstitutionToUserAccountMutation()
    const [createInstitutionMetadataAction, createInstitutionMetadataState] = useCreateInstitutionMetadataMutation()
    const [getMetadataAction, metaDataState] = useLazyGetInstitutionMetadataQuery()
    const [updateInstitutionAction, updateInstitionState] = useUpdateInstitutionMutation()
    const [updateMetadataAction, updateMetadataState] = useUpdateInstitutionMetadataMutation()
    const [uploadImageAction, uploadImageState] = useUploadImageMutation()



    const metaDataStatus = useMemo(() => {
        if (metaDataState.isSuccess) {
            const meta_data = metaDataState.currentData?.metadata
            if (meta_data) {
                return {
                    ...meta_data,
                    api_data: "true"
                }
            } else {
                return {
                    ...institutionMetadata,
                    api_data: "false"
                }
            }
        }
        if (metaDataState.isError) {
            return {
                ...institutionMetadata,
                api_data: "false"
            }
        }
    }, [metaDataState])
    useEffect(() => {
        if (metaDataStatus) {
            if (metaDataStatus.hasOwnProperty("meta_data")) {
                setMetadata(metaDataStatus.meta_data)
            } else {
                setMetadata(metaDataStatus)
            }
        }
    }, [metaDataStatus])

    const createMetadataStatus = useMemo(() => {
        if (createInstitutionMetadataState.isSuccess) {
            return {
                show: true,
                message: createInstitutionMetadataState.data.message,
                type: "success",
                redirect: null
            }
        }
        if (createInstitutionMetadataState.isError) {
            return {
                show: true,
                message: createInstitutionMetadataState.error.data?.detail,
                type: "error",
                redirect: null
            }
        }
    }, [createInstitutionMetadataState])
    useEffect(() => {
        if (createMetadataStatus) {
            setStatus(createMetadataStatus)
        }
    }, [createMetadataStatus])
    const institutionBasicInfo = useMemo(() => {
        if (getUserInstitution.isSuccess) {
            if (getUserInstitution.currentData?.data) {
                return {
                    ...getUserInstitution.currentData.data,
                    api_data: "true"
                }
            } else {
                return {
                    address: "",
                    district: "",
                    logo: "",
                    name: "",
                    pin: "",
                    state: "",
                    api_data: "false"
                }
            }
        } else {
            return {
                address: "",
                district: "",
                logo: "",
                name: "",
                pin: "",
                state: "",
                api_data: "false"
            }
        }
    }, [getUserInstitution])

    useEffect(() => {
        if (institutionBasicInfo) {
            setInstitution(institutionBasicInfo)
        }
    }, [institutionBasicInfo])

    const addInstitutionToUserAccountState = useMemo(() => {
        if (updateUserInstitutionState.isSuccess) {
            if (updateUserInstitutionState.data?.user) {
                const {
                    meta_data
                } = updateUserInstitutionState.data.user
                if (meta_data && meta_data.hasOwnProperty("user_platform")) {
                    const id = meta_data.user_platform
                    id && getUserInstitutionAction(id)
                    id && getMetadataAction(id)

                    return {
                        show: true,
                        message: updateUserInstitutionState.data?.message,
                        type: "success",
                        redirect: null
                    }
                } else {
                    return {
                        show: true,
                        message: "Platform is created but,cloud not able to update to your account!",
                        type: "info",
                        redirect: null
                    }
                }
            } else {
                return {
                    show: true,
                    message: "Institution being created but not able to add your account!",
                    type: "warning",
                    redirect: null
                }
            }
        }
    }, [updateUserInstitutionState])
    useEffect(() => {
        if (addInstitutionToUserAccountState) {
            setStatus(addInstitutionToUserAccountState)
        }
    }, [addInstitutionToUserAccountState])

    useEffect(() => {
        const fetchUser = async () => {
            const userData = await localStorage.getItem("current_user")
            if (userData) {
                const userInfo = JSON.parse(userData)
                if (userInfo && userInfo.user_data) {
                    setUser(userInfo.user_data)
                    const { meta_data } = userInfo.user_data
                    if (meta_data && meta_data.hasOwnProperty("user_platform")) {
                        const id = meta_data.user_platform
                        id && getUserInstitutionAction(id)
                        id && getMetadataAction(id)
                    }
                }
            } else {
                navigation("/auth/login")
            }
        }
        fetchUser()
    }, [])

    React.useEffect(() => {
        const handleAlert = () => {
            if (createState.isError) {
                setAlert({
                    message: createState.error.message,
                    type: "error",
                    show: true
                })
            }
            if (createState.isSuccess) {
                if (user && createState.data.info) {
                    const updateData = {
                        email: user.email,
                        meta_data: {
                            ...user.meta_data,
                            "user_platform": createState.data.info.id
                        }
                    }
                    updateInstitutionToUserAccountAction(updateData)
                }
                setAlert({
                    message: createState.data.message,
                    type: "success",
                    show: true
                })
            }
        }
        handleAlert()
        return () => {
            createState.reset()
        }
    }, [createState])

    const handleCreatePlatform = () => {
        const data = institution

        const isNullPresent = Object.entries(data).find((item) => !item[1])


        if (isNullPresent) {
            setAlert({
                show: true,
                message: `${isNullPresent[0]} field value is missing`,
                type: "info",
                duration: 1000,
                alert_type: "toast"
            })
        } else {
            createPlatform(data)
        }
    }

    function updateMetadata() {
        const data = institutionMetadata

        const isNullPresent = Object.entries(data).find((item) => !item[1])
        if (isNullPresent) {
            setAlert({
                show: true,
                message: `${isNullPresent[0]} field value is missing`,
                type: "info",
                duration: 1000,
                alert_type: "toast"
            })
        } else {
            if (institutionBasicInfo && institutionBasicInfo.id) {
                const id = institutionBasicInfo.id
                createInstitutionMetadataAction({ platform_id: id, meta_data: data })
            }
        }
    }

    function updateInstition() {
        if (institutionBasicInfo && institutionBasicInfo.id) {
            const id = institutionBasicInfo.id
            const data = {
                ...institution
            }

            const isNullPresent = Object.entries(data).find((item) => !item[1])


            if (isNullPresent) {
                setAlert({
                    show: true,
                    message: `${isNullPresent[0]} field value is missing`,
                    type: "info",
                    duration: 1000,
                    alert_type: "toast"
                })
            } else {
                delete data.id
                delete data.api_data

                updateInstitutionAction({ id: id, data: { ...data } })
            }

        }
    }
    const updateInstitionStatus = useMemo(() => {
        if (updateInstitionState.isSuccess) {
            if (institutionBasicInfo && institutionBasicInfo.id) {
                const id = institutionBasicInfo.id
                id && getUserInstitutionAction(id)
                id && getMetadataAction(id)
            }
            return {
                show: true,
                message: updateInstitionState.data?.message,
                type: "success",
                redirect: null
            }
        }
        if (updateInstitionState.isError) {
            return {
                show: true,
                message: "Error while update,Please try again after sometime! ",
                type: "error",
                redirect: null
            }
        }
    }, [updateInstitionState])
    useEffect(() => {
        if (updateInstitionStatus) {
            setStatus(updateInstitionStatus)
        }
    }, [updateInstitionStatus])

    function updateInstitionMetadata() {
        if (metaDataStatus && metaDataStatus.id) {
            const id = metaDataStatus.id
            const data = {
                ...institutionMetadata
            }
            const isNullPresent = Object.entries(data).find((item) => !item[1])


            if (isNullPresent) {
                setAlert({
                    show: true,
                    message: `${isNullPresent[0]} field value is missing`,
                    type: "info",
                    duration: 1000,
                    alert_type: "toast"
                })
            } else {
                updateMetadataAction({ platform_id: id, meta_data: { ...data } })
            }

        }
    }

    const uploadMetadataStatus = useMemo(() => {
        if (updateMetadataState.isSuccess) {
            if (institutionBasicInfo && institutionBasicInfo.id) {
                const id = institutionBasicInfo.id
                id && getUserInstitutionAction(id)
                id && getMetadataAction(id)
            }
            return {
                show: true,
                message: updateMetadataState.data?.message,
                type: "success",
                redirect: null
            }
        }
        if (updateMetadataState.isError) {
            return {
                show: true,
                message: "Error while update,Please try again after sometime! ",
                type: "error",
                redirect: null
            }
        }
    }, [updateMetadataState])

    useEffect(() => {
        if (uploadMetadataStatus) {
            setStatus(uploadMetadataStatus)
        }
    }, [uploadMetadataStatus])

    const uploadImageStatus = useMemo(() => {
        if (uploadImageState.isSuccess || !institution) {
            let data = {
                ...institution,
                "logo": JSON.stringify(uploadImageState.data)
            }
            updateInstitutionAction({ id: data.id, data: { ...data } })
            setInstitution((prevState) => ({ ...prevState, logo: JSON.stringify(uploadImageState.data) }))

            return {
                show: true,
                message: uploadImageState.data.message,
                type: "success"
            }
        }
        if (uploadImageState.isError) {
            return {
                show: true,
                message: "Error while upload the image",
                type: "error"
            }
        }
    }, [uploadImageState])

    useEffect(() => {
        if (uploadImageStatus) {
            setStatus(uploadImageStatus)
        }
    }, [uploadImageStatus])

    const getLogoUrl = (logo) => {
        try {
            return JSON.parse(logo)?.url || "";
        } catch (error) {
            console.error("Invalid logo JSON:", error);
            return "";
        }
    }


    const isCreated = institutionBasicInfo?.api_data === "true"
    const hasMetadata = metaDataStatus?.api_data === "true"
    const logoUrl = getLogoUrl(institution.logo)
    const isSaving =
        createState.isLoading ||
        updateInstitionState.isLoading ||
        updateUserInstitutionState.isLoading
    const isSavingMetadata =
        createInstitutionMetadataState.isLoading ||
        updateMetadataState.isLoading

    const setField = (field) => (e) => {
        const value = e.target.value.toLowerCase()
        setInstitution((prevState) => ({ ...prevState, [field]: value }))
    }
    const setMetadataField = (field) => (e) => {
        const value = e.target.value.toLowerCase()
        setMetadata((prevState) => ({ ...prevState, [field]: value }))
    }

    const fieldSx = {
        "& .MuiOutlinedInput-root": { borderRadius: "12px", bgcolor: "#fff" },
        "& .MuiInputBase-input": { textTransform: "capitalize" }
    }
    const primaryButtonSx = {
        textTransform: "none",
        fontWeight: 700,
        borderRadius: "10px",
        px: 3,
        py: 1.1,
        bgcolor: "var(--color-primary)",
        boxShadow: "none",
        "&:hover": { bgcolor: "var(--color-primary-hover)", boxShadow: "none" }
    }

    const location = [institution.district, institution.state].filter(Boolean).join(", ")

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5, maxWidth: 960 }}>

            {/* ================= OVERVIEW ================= */}

            <Paper elevation={0} sx={{
                p: { xs: 2, md: 3 },
                borderRadius: "16px",
                border: "1px solid var(--border-color)",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "flex-start", sm: "center" },
                gap: 2.5
            }}>
                <Box sx={{ position: "relative", flexShrink: 0 }}>
                    <Avatar
                        src={logoUrl || undefined}
                        variant="rounded"
                        sx={{
                            width: 84,
                            height: 84,
                            borderRadius: "18px",
                            bgcolor: "var(--color-primary-light)",
                            color: "var(--color-primary)",
                            fontSize: 28,
                            fontWeight: 700,
                            textTransform: "uppercase"
                        }}
                    >
                        {(institution.name || "?").slice(0, 1)}
                    </Avatar>
                    <Tooltip title={isCreated ? "Upload logo" : "Save the institution details first"}>
                        <span style={{ position: "absolute", right: -8, bottom: -8 }}>
                            <Button
                                component="label"
                                disabled={!isCreated || uploadImageState.isLoading}
                                aria-label="Upload institution logo"
                                sx={{
                                    minWidth: 0,
                                    width: 34,
                                    height: 34,
                                    borderRadius: "50%",
                                    bgcolor: "#fff",
                                    border: "1px solid var(--border-color)",
                                    color: "var(--color-primary)",
                                    boxShadow: "var(--shadow-sm)",
                                    "&:hover": { bgcolor: "var(--color-primary-light)" }
                                }}
                            >
                                <PhotoCameraOutlined sx={{ fontSize: 18 }} />
                                <input
                                    hidden
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => {
                                        const file = e.target.files[0]
                                        file && uploadImageAction({ file })
                                        e.target.value = ""
                                    }}
                                />
                            </Button>
                        </span>
                    </Tooltip>
                </Box>

                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography sx={{
                        fontFamily: "var(--font-heading)",
                        fontWeight: 700,
                        fontSize: { xs: 20, md: 24 },
                        color: "var(--text-primary)",
                        textTransform: "capitalize",
                        lineHeight: 1.2
                    }}>
                        {institution.name || "Your institution"}
                    </Typography>
                    {location ? (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5, color: "var(--text-secondary)" }}>
                            <PlaceOutlined sx={{ fontSize: 16 }} />
                            <Typography sx={{ fontSize: 13, textTransform: "capitalize" }}>
                                {location}{institution.pin ? ` · ${institution.pin}` : ""}
                            </Typography>
                        </Box>
                    ) : (
                        <Typography sx={{ fontSize: 13, color: "var(--text-secondary)", mt: 0.5 }}>
                            Fill in the details below to set up your institution.
                        </Typography>
                    )}
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1.5 }}>
                        <Chip
                            size="small"
                            icon={isCreated ? <CheckCircleOutline /> : <InfoOutlined />}
                            label={isCreated ? "Profile created" : "Not set up yet"}
                            sx={{
                                fontWeight: 600,
                                borderRadius: "8px",
                                color: isCreated ? "#047857" : "#b45309",
                                bgcolor: isCreated ? "#ecfdf5" : "#fffbeb",
                                "& .MuiChip-icon": { color: "inherit" }
                            }}
                        />
                        {isCreated && (
                            <Chip
                                size="small"
                                label={hasMetadata ? "Additional details added" : "Additional details missing"}
                                sx={{
                                    fontWeight: 600,
                                    borderRadius: "8px",
                                    color: hasMetadata ? "#047857" : "var(--text-secondary)",
                                    bgcolor: hasMetadata ? "#ecfdf5" : "#f1f5f9"
                                }}
                            />
                        )}
                    </Box>
                </Box>
            </Paper>

            {/* ================= TABS ================= */}

            <Paper elevation={0} sx={{ borderRadius: "16px", border: "1px solid var(--border-color)", overflow: "hidden" }}>
                <Tabs
                    value={state.setup_step}
                    onChange={(e, val) => setState((prevState) => ({ ...prevState, setup_step: val }))}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        px: 1,
                        borderBottom: "1px solid var(--border-color)",
                        "& .MuiTab-root": {
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: 14,
                            minHeight: 54,
                            color: "var(--text-secondary)"
                        },
                        "& .Mui-selected": { color: "var(--color-primary) !important" },
                        "& .MuiTabs-indicator": { bgcolor: "var(--color-primary)", height: 3, borderRadius: "3px 3px 0 0" }
                    }}
                >
                    <Tab value="new_institution" label="Institution details" />
                    <Tab value="metadata_institution" label="Additional details" disabled={!isCreated} />
                    <Tab value="member_institution" label="Members" disabled={!isCreated} />
                </Tabs>

                {/* ---------- Institution details ---------- */}

                {state.setup_step === "new_institution" && (
                    <Box sx={{ p: { xs: 2, md: 3 } }}>
                        <Typography sx={{ fontWeight: 700, fontSize: 16, color: "var(--text-primary)" }}>
                            Basic information
                        </Typography>
                        <Typography sx={{ fontSize: 13, color: "var(--text-secondary)", mb: 2.5 }}>
                            {isCreated
                                ? "Keep your institution's name and address up to date."
                                : "Create your institution to unlock the rest of the settings."}
                        </Typography>

                        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2 }}>
                            <TextField
                                label="Institution name"
                                placeholder="Enter institution name"
                                value={institution.name || ""}
                                onChange={setField("name")}
                                sx={{ ...fieldSx, gridColumn: "1 / -1" }}
                            />
                            <TextField
                                label="State"
                                placeholder="Enter state"
                                value={institution.state || ""}
                                onChange={setField("state")}
                                sx={fieldSx}
                            />
                            <TextField
                                label="District"
                                placeholder="Enter district"
                                value={institution.district || ""}
                                onChange={setField("district")}
                                sx={fieldSx}
                            />
                            <TextField
                                label="PIN code"
                                placeholder="Enter PIN code"
                                value={institution.pin || ""}
                                onChange={setField("pin")}
                                inputProps={{ inputMode: "numeric", maxLength: 10 }}
                                sx={fieldSx}
                            />
                            <Box sx={{ display: { xs: "none", sm: "block" } }} />
                            <TextField
                                label="Address"
                                placeholder="Enter institution address"
                                multiline
                                minRows={3}
                                value={institution.address || ""}
                                onChange={setField("address")}
                                sx={{ ...fieldSx, gridColumn: "1 / -1" }}
                            />
                        </Box>

                        {!isCreated && (
                            <Typography sx={{ fontSize: 12, color: "var(--text-light)", mt: 1.5 }}>
                                You can upload a logo once the institution is created.
                            </Typography>
                        )}

                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
                            <Button
                                variant="contained"
                                disabled={isSaving}
                                onClick={isCreated ? updateInstition : handleCreatePlatform}
                                sx={primaryButtonSx}
                            >
                                {isSaving ? "Saving…" : isCreated ? "Save changes" : "Create institution"}
                            </Button>
                        </Box>
                    </Box>
                )}

                {/* ---------- Additional details ---------- */}

                {state.setup_step === "metadata_institution" && (
                    <Box sx={{ p: { xs: 2, md: 3 } }}>
                        <Typography sx={{ fontWeight: 700, fontSize: 16, color: "var(--text-primary)" }}>
                            Additional details
                        </Typography>
                        <Typography sx={{ fontSize: 13, color: "var(--text-secondary)", mb: 2.5 }}>
                            Contact and accreditation details shown on admit cards, certificates and receipts.
                        </Typography>

                        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2 }}>
                            <TextField
                                label="Institution code"
                                placeholder="Enter institution code"
                                value={institutionMetadata?.institutionCode || ""}
                                onChange={setMetadataField("institutionCode")}
                                sx={fieldSx}
                            />
                            <TextField
                                label="Institution type"
                                placeholder="School, college, university…"
                                value={institutionMetadata?.institutionType || ""}
                                onChange={setMetadataField("institutionType")}
                                sx={fieldSx}
                            />
                            <TextField
                                label="Email address"
                                placeholder="Enter official email"
                                type="email"
                                value={institutionMetadata?.institutionEmail || ""}
                                onChange={setMetadataField("institutionEmail")}
                                sx={{ ...fieldSx, "& .MuiInputBase-input": { textTransform: "none" } }}
                            />
                            <TextField
                                label="Contact number"
                                placeholder="Enter contact number"
                                type="tel"
                                value={institutionMetadata?.institutionContact || ""}
                                onChange={setMetadataField("institutionContact")}
                                sx={fieldSx}
                            />
                            <TextField
                                label="Year of establishment"
                                placeholder="e.g. 1995"
                                value={institutionMetadata?.establishmentYear || ""}
                                onChange={setMetadataField("establishmentYear")}
                                inputProps={{ inputMode: "numeric", maxLength: 4 }}
                                sx={fieldSx}
                            />
                            <TextField
                                label="Board, university or accreditation body"
                                placeholder="e.g. CBSE"
                                value={institutionMetadata?.board || ""}
                                onChange={setMetadataField("board")}
                                sx={fieldSx}
                            />
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
                            <Button
                                variant="contained"
                                disabled={isSavingMetadata}
                                onClick={hasMetadata ? updateInstitionMetadata : updateMetadata}
                                sx={primaryButtonSx}
                            >
                                {isSavingMetadata ? "Saving…" : hasMetadata ? "Save changes" : "Save details"}
                            </Button>
                        </Box>
                    </Box>
                )}

                {/* ---------- Members ---------- */}

                {state.setup_step === "member_institution" && (
                    <InstitutionMembers
                        institutionBasicInfo={institutionBasicInfo}
                        institutionMetadata={metaDataStatus}
                        user={user}
                    />
                )}
            </Paper>

            {
                alert.show && (
                    <ToastMessage
                        message={alert.message}
                        type={alert.type}
                        show={alert.show}
                        onClose={() => {
                            setAlert({
                                type: null,
                                show: false,
                                message: ""
                            })
                        }}
                    />
                )
            }
            {
                status && (
                    <ToastMessage
                        {...status}
                        onClose={() => {
                            setStatus(null)
                        }}
                    />
                )
            }
            {
                (
                    getUserInstitution.isLoading ||
                    metaDataState.isLoading ||
                    uploadImageState.isLoading
                ) && (
                    <Loader
                        show={true}
                    />
                )
            }
        </Box>
    );
}

export default PlatformSetup
